import React from "react";
import { Link } from "react-router-dom";
import Chart from "react-google-charts";

const TYPE_COLORS = {
  CERAMIC: "#c82534",
  DIESEL: "#2c6fbb",
  "AFTER MKT": "#00965a",
  "DOMESTIC WIRE": "#e8a317",
  "FOREIGN WIRE": "#6b4c9a",
};

function truncateLabel(label, max = 22) {
  if (!label) return "—";
  return label.length > max ? `${label.slice(0, max)}…` : label;
}

export function TopTestedVisual({ summary }) {
  const oems = summary?.topTestedOems || [];
  const byType = summary?.byType || [];

  if (!oems.length) {
    return (
      <div className="converter-testing-glance-panel converter-testing-top-tested-panel">
        <div className="converter-testing-glance-title">Top tested</div>
        <div className="c-gray fs-14">No tested converters match the current filters.</div>
      </div>
    );
  }

  const topChartRows = oems.slice(0, 15);
  const chartData = [
    ["OEM", "Tests"],
    ...topChartRows.map((row) => [truncateLabel(row.oem || row.productId), row.testCount ?? 0]),
  ];

  return (
    <div className="converter-testing-glance-panel converter-testing-top-tested-panel">
      <div className="converter-testing-glance-header">
        <div>
          <div className="converter-testing-glance-title">Top tested — OEMs at a glance</div>
          <div className="converter-testing-glance-subtitle c-gray fs-13">
            {oems.length.toLocaleString()} converters ranked by test count
            {(summary?.totalTestRecords ?? 0) > 0 &&
              ` · ${summary.totalTestRecords.toLocaleString()} total test records`}
          </div>
        </div>
        <div className="converter-testing-glance-badge converter-testing-glance-badge-green">
          {oems.length.toLocaleString()}
        </div>
      </div>

      <div className="converter-testing-no-tests-charts">
        {topChartRows.length > 0 && (
          <div className="converter-testing-chart-card">
            <div className="converter-testing-chart-title">Top 15 by test count</div>
            <Chart
              chartType="BarChart"
              width="100%"
              height={Math.max(220, topChartRows.length * 22)}
              data={chartData}
              options={{
                legend: { position: "none" },
                chartArea: { width: "55%", height: "80%", left: 140 },
                hAxis: { textStyle: { fontSize: 11 }, minValue: 0 },
                vAxis: { textStyle: { fontSize: 10 } },
                colors: ["#00965a"],
                bar: { groupWidth: "70%" },
              }}
              loader={<div className="c-gray fs-13">Loading chart...</div>}
            />
          </div>
        )}

        <div className="converter-testing-no-tests-legend">
          {byType.map((row) => (
            <div key={row.type} className="converter-testing-type-legend-item">
              <span
                className="converter-testing-type-dot"
                style={{ background: TYPE_COLORS[row.type] || "#999" }}
              />
              <span className="fs-12 fw-bolder">{row.type}</span>
              <span className="fs-12 c-gray">({row.count})</span>
            </div>
          ))}
        </div>
      </div>

      <div className="converter-testing-oem-chip-grid">
        {oems.map((item, index) => {
          const typeColor = TYPE_COLORS[item.type] || "#999";
          return (
            <Link
              key={item.productId}
              to={`/converter/${item.productId}`}
              className="converter-testing-oem-chip converter-testing-oem-chip-ranked"
              style={{ borderLeftColor: typeColor }}
              title={`${item.type} · ${item.testCount ?? 0} tests`}
            >
              <span className="converter-testing-oem-chip-rank">#{index + 1}</span>
              <span className="converter-testing-oem-chip-text">{item.oem || item.productId}</span>
              <span className="converter-testing-oem-chip-meta">
                <span className="converter-testing-oem-chip-type">{item.type}</span>
                <span className="converter-testing-oem-chip-count">{item.testCount ?? 0} tests</span>
              </span>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
